import * as React from "react";
import { useAuth } from "../../contexts";
import { ITabsProps, Tabs } from "@blueprintjs/core";
import { useLocation, useHistory } from "react-router";

export interface IProtectedTabsProps extends ITabsProps {}

export const ProtectedTabs: React.FunctionComponent<IProtectedTabsProps> = ({ ...props }) => {
  const { matchTab } = useAuth();
  const location = useLocation();
  const history = useHistory();

  const filteredTabs = React.useMemo<any>(() => {
    if (Array.isArray(props.children)) {
      return props.children.filter((d: any) => {
        if (d?.type?.displayName === "Blueprint3.Tab") {
          return matchTab(d.props.id.toString());
        } else {
          return true;
        }
      });
    }
    return props.children;
  }, [matchTab, props.children]);

  React.useEffect(() => {
    if (filteredTabs && Array.isArray(filteredTabs) && filteredTabs.length > 0) {
      let tab = null;
      const tabString = location.pathname.split("/")[3]
        ? location.pathname.split("/")[3]
        : location.pathname.split("/")[2];

      if (!filteredTabs.some((d) => (d?.props?.id?.toUpperCase() ?? "") === tabString?.toUpperCase())) {
        for (let d of filteredTabs) {
          if (d?.type?.displayName === "Blueprint3.Tab" && !tab) {
            tab = d;
          }
        }
      }

      if (tab && tabString?.toUpperCase() !== tab.props.id.toUpperCase()) {
        let url = location.pathname.replace(`/${tabString}/`, `/${tab.props.id}/`);
        url = url.substr(0, url.indexOf(`/${tab.props.id}/`) + `/${tab.props.id}/`.length);
        history.push(url);
      }
    }
  }, [filteredTabs, history, location.pathname]);

  return <Tabs {...props} children={filteredTabs} />;
};
